import React, { PropsWithChildren, useEffect, useRef, useState } from 'react'
import { RouteObject } from 'react-router-dom'
import { getStatus } from '@plug-core/handlers/walletActions/wallet'
import { WalletStatusResponse } from '@plug-core/interfaces/walletActions'
import { initializeMessenger } from '@core/messengers'
import { WALLET_SETUP_ROUTE_DATA, WalletSetup } from '@modules/WalletSetup'
import { WalletUnlock } from '@modules/Wallet/Components/WalletUnlock'
import { ROUTE_DATA } from '@components/Router/Router'
import { isWebEnvironment } from '@utils/environment'

const backgroundMessenger = initializeMessenger({ connect: 'background' })

export default ({ children }: PropsWithChildren) => {
  const [accountState, setAccountState] = useState({
    isReady: false,
    hasVault: false,
    hasPassword: false,
    unlocked: false,
  })

  console.log({ accountState })

  const hadAccount = useRef<boolean>()

  const saveState = async (state: WalletStatusResponse) => {
    setAccountState(state)

    if (state.isReady && hadAccount.current === undefined) {
      hadAccount.current = state.hasVault && state.hasPassword
    }
  }

  useEffect(() => {
    getStatus().then(saveState)
    backgroundMessenger.reply('wallet-state-changed', saveState)
  }, [])

  // Since we have 2 routers controlled by IF with differing routes
  // check here that the current path belongs to router being used
  // and redirect to the routers root path if not
  const navigateToRouterRoot = (routes: RouteObject[]) => {
    const currentPath = window.location.hash.replace(/^#\//, '/')

    if (!routes.find((route) => route.path === currentPath)) {
      const route = routes.find((route) => route.index)

      window.history.replaceState(null, '')
      window.location.hash = `#${route!.path}`
    }
  }

  const isAccountJustCreated =
    accountState.hasVault && accountState.hasPassword && !hadAccount.current

  if (!accountState.isReady) {
    return null
  } else if (!accountState.hasVault || !accountState.hasPassword) {
    navigateToRouterRoot(WALLET_SETUP_ROUTE_DATA)
    return <WalletSetup />
  } else if (isAccountJustCreated && !isWebEnvironment()) {
    // Only show success screen for extensions, not web
    navigateToRouterRoot(WALLET_SETUP_ROUTE_DATA)
    return <WalletSetup />
  } else if (!accountState.unlocked) {
    return <WalletUnlock />
  } else {
    navigateToRouterRoot(ROUTE_DATA)
    return children
  }
}
